import {UserNewModalForm} from './UserNewModalForm'

const UserNewModalFormWrapper = () => {
    return <UserNewModalForm />

}

export {UserNewModalFormWrapper}
